import { Flex, Spinner } from '_shared/designSystem/components';

export default function LoadingSpinner() {
  return (
    <Flex pt={150} justify="center" data-testid="loadingSpinner">
      <Spinner color="primary.500" />
    </Flex>
  );
}
